/**
* @name: collapse-menu
* @author: weiyong
* @date: 2023-05-11 18:49
* @description：collapse-menu
* @update: 2023-05-11 18:49
*/
<template>
  <a-menu
    v-if="showMenuFlag"
    class="scaLayoutMenu"
    v-model:openKeys="openKeys"
    v-model:selectedKeys="selectedKeys"
    mode="inline"
    :inline-collapsed="!openFlag"
    @click="menuClick"
  >

    <div class="menu-item-div" v-for="menuItem in menusRef" :key="menuItem.id || menuItem.path" :class="[menuItem.type]">
      <a-sub-menu :key="menuItem.id" v-if="menuItem.type==='menu'">
        <template #icon>
          <!-- 参考经典模式：图标槽只放图标，文字走 #title -->
          <xm-menu-li class="flex-div" :activeItem="isActiveItem(menuItem.id)" :openFlag="false"
                      :menuItem="menuItem"/>
        </template>
        <template #title>
          <span class="menu-title-text" :title="menuItem.label || menuItem.name">
            {{ menuItem.label || menuItem.name }}
          </span>
        </template>

        <template v-for="sonMenuItem in menuItem.children" :key="sonMenuItem.id || sonMenuItem.path">
          <!--子菜单-->
          <xm-menu-sub v-if="sonMenuItem.type==='menu'" :selectedKeys="selectedKeys"
                       :openFlag="openFlag" :menuItem="sonMenuItem"/>
          <!--界面-->
          <a-menu-item v-if="sonMenuItem.type==='page'" :key="String(sonMenuItem.id || sonMenuItem.path)"
                       class="el-custom-sidebar-item">
            <template #icon>
              <xm-menu-li :activeItem="isActiveItem(String(sonMenuItem.id || sonMenuItem.path))" :openFlag="false"
                          :menuItem="sonMenuItem"/>
            </template>
            <!-- 始终渲染文案：展开态显示+省略号，折叠态由 CSS 隐藏（供 tooltip） -->
            <span class="menu-title-text" :title="sonMenuItem.label || sonMenuItem.name">
              {{ sonMenuItem.label || sonMenuItem.name }}
            </span>
          </a-menu-item>
        </template>
      </a-sub-menu>

      <a-menu-item v-if="menuItem.type==='page'" :key="String(menuItem.id || menuItem.path)"
                   class="el-custom-sidebar-item">
        <template #icon>
          <xm-menu-li :activeItem="isActiveItem(String(menuItem.id || menuItem.path))" :openFlag="false"
                      :menuItem="menuItem"/>
        </template>
        <span class="menu-title-text" :title="menuItem.label || menuItem.name">
          {{ menuItem.label || menuItem.name }}
        </span>
      </a-menu-item>

    </div>
  </a-menu>

</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "collapse-menu",
});
</script>

<script lang="ts" setup>
import XmMenuSub from "@/layouts/layoutFrame/environmental/components/xm-menu-sub.vue";
import XmMenuLi from "@/layouts/layoutFrame/scaLayout/components/xm-menu-li.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {Menu as aMenu, MenuItem as aMenuItem, SubMenu as aSubMenu} from 'ant-design-vue';
import {useMenuHooks} from "@/layouts/layoutFrame/hooks/useMenuHooks";
import {useRouter} from "vue-router";
import {useSpaceHook} from "@/hooks/layouts/useSpaceHook";
import {useI18n} from "@/hooks/web/useI18n";
import eventBus from "@/events/eventBus";
import {getMenuObjByKey} from "@/utils/buryingPoint";
import {executeSetCrumbName} from "@/layouts/layoutFrame/scaLayout/hooks/useBreadCrumbHook";
import {useAppStore} from "@/store/modules/app";


const {prefixCls} = useDesign('environmental-collapse-menu');
const selectedKeys = ref([]);
const openKeys = ref([]);

const isActiveItem = function (key) {
  const activeItem = unref(selectedKeys).filter((itemDb) => {
    return key === itemDb
  })[0];
  if (activeItem) {
    return true;
  } else {
    return false;
  }
}

const props = defineProps({
  openFlag: {}
})
const {openFlag} = toRefs(props);
const showMenuFlag = ref(true);

const {
  panelSty,
  getCurSpaceItem,
}: any = useSpaceHook();

const router = useRouter();
const {t} = useI18n();


const _onClearActiveMenu=({item}) => {
  selectedKeys.value = [];
}
onBeforeMount(() => {
  eventBus.off('onClearActiveMenu',_onClearActiveMenu);
})

onMounted(() => {
  eventBus.off('onClearActiveMenu',_onClearActiveMenu);
  eventBus.on('onClearActiveMenu', _onClearActiveMenu);
})
const {
  menuClickFlag,
  afterClickMenuByTarget,
  menusRef,
  genAppMenus,
  menuClick
} = useMenuHooks(router, t);
// 绿色环保主题不展示首页菜单，与大海深蓝折叠态一致
genAppMenus(false, () => {

});
watch(
  () => router.currentRoute.value,
  (newValue) => {
    //如果是用户点击菜单 发生的变更 则不需要跳转了
    if (unref(menuClickFlag)) {
      menuClickFlag.value = false;
      return void (0)
    }
    let curUrl=newValue.path;
    if(curUrl.indexOf('/xm-ngs/quality-control-plan')>=0){
      curUrl='/xm-ngs/quality-control-plan';
    }
    const targetObj: any = {};
    getMenuObjByKey(unref(menusRef), curUrl, targetObj);
    if (targetObj && targetObj.target) {
      if (targetObj.target.parentId) {
        unref(openKeys).push(targetObj.target.parentId)
      }
      afterClickMenuByTarget({targetObj, key: curUrl});
      selectedKeys.value = [];
      unref(selectedKeys).push(String(targetObj.target.id || targetObj.target.path));
    }else{
      executeSetCrumbName({path:curUrl});
    }
  })
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-environmental-collapse-menu';

.ant-menu {
  .menu-item-div {
    // 经典模式无额外 wrapper 间距，行距由菜单项 padding:14px 控制
    padding: 0;

    &:first-of-type {
      padding-top: 0;
    }

    &:last-of-type {
      padding-bottom: 0;
    }
  }

}

.@{prefix-cls} {

  &.branding-container {
    --el-custom-sidebar-base-level-padding: 20px;
    padding-top: 24px;
    height: 47px;
    margin-bottom: 24px;

    .branding {
      display: flex;
      flex-direction: row;
      gap: 8px;
    }

    .company-name {
      color: var(--el-color-white);
      height: 38px;
      line-height: 38px;
      font-family: GoodTimes;
    }

    .logo-container {
      background-color: var(--el-color-white);
      border-radius: 19px;
      padding: 4px;
      margin-left: calc(var(--el-custom-sidebar-base-level-padding));
    }

    .company-logo {
      width: 30px;
      height: 30px;
      display: block;
      border-radius: 30px;
      margin-left: auto;
      margin-right: auto;
    }

    img {
      min-width: 30px;
    }


  }
}
</style>
